import services from '@/http'
import api from '@/modules/api'
import * as storage from '../storage'
import * as types from './mutation-types'

const baseUrl = (process.env.NODE_ENV === 'development') ?
        `http://${window.location.hostname}:8081/sgm` :
        `http://${window.location.hostname}:8081/sgm`;

export const ActionDoLogin = ({ dispatch }, payload) => {
    return api.post(`${baseUrl}/login`, payload).then(async res => {
        dispatch('ActionSetToken', res.data.token);

        await api.get('/sgm/sessao').then(res => {
            const userData = {
                funcionario_id: res.data.funcionario_id,
                helpdesk_grupo_id: res.data.helpdesk_grupo_id,
                parceiro_rede_neutra_id: res.data.parceiro_rede_neutra_id,
                login: res.data.login,
                email: res.data.email,
                nomeFuncionario: res.data.nome_funcionario,
                config: res.data.config,
            };

            dispatch('ActionSetUser', res.data.login);
            dispatch('ActionSetUserData', userData);
        }).catch(() => {
            console.log('erro ao obter dados da sessão');
            dispatch('ActionSetToken', '');
        });
    });
}

export const ActionCheckCompanyData = async ({ dispatch }) => {
    /*const localCompanyData = storage.getLocalCompanyData();

    if (localCompanyData) {
        return Promise.resolve(localCompanyData)
    }*/

    return api.get('/sgm/empresa').then(res => {
        dispatch('ActionSetCompanyData', res.data);
    }).catch(err => {
        console.error('erro ao obter dados da empresa', err);
        dispatch('ActionSetCompanyData', {});
    });
}

export const ActionCheckToken = ({ dispatch, state }) => {
    if (state.token) {
        return Promise.resolve(state.token)
    }

    const token = storage.getLocalToken();
    const userData = JSON.parse(storage.getLocalUserData());

    if (!token || !userData || !userData.nomeFuncionario) {
        return Promise.reject(new Error('Token inválido'))
    }

    dispatch('ActionSetToken', token)
    dispatch('ActionSetUserData', userData);
    return dispatch('ActionLoadSession');
}

export const ActionLoadSession = ({ dispatch }) => {
    return (async (resolve, reject) => {
      try {
        const { data: { user } } = await services.auth.loadSession()

        dispatch('ActionSetUser', user)
        resolve()
      } catch (err) {
        dispatch('ActionSignOut')
        reject(err)
      }
    })
  }

export const ActionSetUser = ({ commit }, payload) => {
    commit(types.SET_USER, payload);
}

export const ActionSetUserData = ({ commit }, payload) => {
    storage.setLocalUserData(JSON.stringify(payload))
    commit(types.SET_USER_DATA, payload);
}

export const ActionSetCompanyData = ({ commit }, payload) => {
    storage.setLocalCompanyData(JSON.stringify(payload))
    commit(types.SET_COMPANY_DATA, payload);

    storage.setCompanyDataLoaded(true);
    commit(types.SET_COMPANY_DATA_LOADED, true);
}

export const ActionSetToken = ({ commit }, payload) => {
    storage.setLocalToken(payload)
    storage.setHeaderToken(payload)
    commit(types.SET_TOKEN, payload);
}

export const ActionSignOut = ({ dispatch }) => {
    storage.setHeaderToken('')
    storage.deleteLocalToken()
    dispatch('ActionSetUser', {})
    dispatch('ActionSetUserData', {})
    dispatch('ActionSetToken', '')
}